import { Tab } from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { BackButton, PageBase, ProtectedTabs } from "../../../../../components";
import { ERoutes } from "../../../../../ERoutes";
import { useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";
import { PersonSplit } from "./PersonSplit";

export interface IPersonSplitItemPageProps {}

export const PersonSplitItemPage: React.FunctionComponent<IPersonSplitItemPageProps> = (props) => {
  const { id, tab } = useParams<{ id: string; tab: string }>();
  const { t } = useTl();
  const history = useHistory();

  return (
    <PageBase
      breadCrumbs={[
        {
          text: t(ETLCodes.Split),
          route: ERoutes.personSplit,
        },
      ]}
    >
      <ProtectedTabs
        id="SplitPersonTabs"
        onChange={(newTabId) => history.push(`${ERoutes.people}/${id}/${newTabId}/edit`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.people}/>
        <Tab id="split" title={t(ETLCodes.Split)} panel={<PersonSplit originalPersonId={+id} />} />
      </ProtectedTabs>
    </PageBase>
  );
};
